export default {
  methods: {
    inputErrors(e) {
      e.forEach(({ field, title }) => this.createError(field, title));
    },

    createError(field, msg) {
      this.$validator.errors.add({
        field,
        msg
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/errorMixin.js